import { config } from "config";
import { CompanyState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;

const initialState: CompanyState = {
	companies: [],
	company: null,
	loading: true,
	company_requests: [],
	companyOptions: [],
	companyCustomers: [],
	companyUsers: [],
  companyCustomersOptions: [],
  paymentOptions: [],
  selectedCompany: {},
  filters: { page: 1, page_size: default_page_size },
  count: 0,
  refresh: 0,
  refreshLoader: false,
  current_filters: { },
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
    },
    setCompanies: (state, action) => {
      const { companies, count } = action.payload;
      let options: SelectOption[] = [];
      companies.forEach(({ _id, company_name }: any) =>
        options.push({ value: _id, label: company_name })
      );
      state.companies = companies;
      state.companyOptions = options;
      state.count = count;
      state.refreshLoader = false;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    addCompany: (state, action) => {
      state.companies.unshift(action.payload);
    },
    updateCompany: (state, action) => {
      const { id, company } = action.payload;
      state.companies.every(({ _id }, i) => {
        if (id === _id) {
          state.companies[i] = company;
          return false;
        }
        return true;
      });
    },
    setCompany: (state, action) => {
      state.company = action.payload;
    },
    setCompanyUsers: (state, action) => {
      state.companyUsers = action.payload;
    },
    setCompanyCustomers: (state, action) => {
      const companyCustomers = action.payload;
      let options: SelectOption[] = [];
      companyCustomers.forEach(({ _id, first_name, last_name }: any) =>
        options.push({ value: _id, label: first_name + " " + last_name })
      );
      state.companyCustomers = companyCustomers;
      state.companyCustomersOptions = options;
    },
    setPaymentOptions: (state, action) => {
      const values = action.payload;
      let options: SelectOption[] = [];
      values.forEach((data:any) =>
      
      options.push({ value: data, label: data }),
      );
      state.paymentOptions = options;
    },
    setCompanyRequests: (state, action) => {
      state.company_requests = action.payload;
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
    deleteCompanyRequestById: (state, action) => {
      const id = action.payload;
      state.company_requests = state.company_requests.filter(
        ({ _id }) => id !== _id
      );
    },
    updateCompanyContacts: (state, action) => {
      if (state.company) {
        state.company.companyContacts = [
          ...(state.company.companyContacts || []),
          action.payload,
        ];
      }
    },
  },
});

const companyReducer = companySlice.reducer;

export const companyActions = companySlice.actions;
export default companyReducer;
